import { Component, inject } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { Router } from '@angular/router'

import { ProfileManagement } from '@cyborg-monorepo/hunter/common'

import { ConfirmedValidator } from '../../../helpers/password.validator'
import { UserService } from '../../../modules/shared/services/user.service'

@Component({
  standalone: false,
  templateUrl: './new-password.component.html',
  styleUrls: ['./new-password.component.scss'],
})
export class NewPasswordComponent {
  private formBuilder = inject(FormBuilder)
  private userService = inject(UserService)
  private router = inject(Router)

  public newPasswordForm: FormGroup
  public formSubmitted = false
  public error = ''
  public passRequirements = ProfileManagement.passwordDescription
  public passRegex = new RegExp(ProfileManagement.passwordRegEx)

  constructor() {
    this.newPasswordForm = this.formBuilder.group(
      {
        password: ['', Validators.required],
        confirmPassword: ['', Validators.required],
      },
      { validator: ConfirmedValidator('password', 'confirmPassword') },
    )
  }

  public onUpdatePassword(): void {
    this.error = ''

    const password = {
      password: this.newPasswordForm.value.confirmPassword,
    }

    this.userService.updatePassword(password).subscribe(
      () => {
        this.formSubmitted = true
      },
      (error) => {
        this.error = error.message
      },
    )
  }
}
